export default __webpack_public_path__ + "static/media/Customer.425efc50.jpg";